/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  DirectorLicensingFeePerRateBreakdown,
  DirectorLicensingFeePerRateBreakdownFromJSON,
  DirectorLicensingFeePerRateBreakdownToJSON,
} from './'

/**
 * The director's details
 * @export
 * @interface FetchLicensedDirectorBillingDetailsResponseDirector
 */
export interface FetchLicensedDirectorBillingDetailsResponseDirector {
  /**
   * The director's first name.
   * @type string
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  firstName: string
  /**
   * The director's last name.
   * @type string
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  lastName: string
  /**
   * Unique identifier for the director as an actor.
   * @type number
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  actorKey?: number
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  totalPaid: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  totalOwed: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  licensingDue: CashAmount
  /**
   *
   * @type {Array<DirectorLicensingFeePerRateBreakdown>}
   * @memberof FetchLicensedDirectorBillingDetailsResponseDirector
   */
  breakdown: Array<DirectorLicensingFeePerRateBreakdown>
}

export function FetchLicensedDirectorBillingDetailsResponseDirectorFromJSON(
  json: any
): FetchLicensedDirectorBillingDetailsResponseDirector {
  return FetchLicensedDirectorBillingDetailsResponseDirectorFromJSONTyped(
    json,
    false
  )
}

export function FetchLicensedDirectorBillingDetailsResponseDirectorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLicensedDirectorBillingDetailsResponseDirector {
  if (json === undefined || json === null) {
    return json
  }
  return {
    firstName: json['firstName'],
    lastName: json['lastName'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
    totalPaid: CashAmountFromJSON(json['totalPaid']),
    totalOwed: CashAmountFromJSON(json['totalOwed']),
    licensingDue: CashAmountFromJSON(json['licensingDue']),
    breakdown: (json['breakdown'] as Array<any>).map(
      DirectorLicensingFeePerRateBreakdownFromJSON
    ),
  }
}

export function FetchLicensedDirectorBillingDetailsResponseDirectorToJSON(
  value?: FetchLicensedDirectorBillingDetailsResponseDirector | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    firstName: value.firstName,
    lastName: value.lastName,
    actorKey: value.actorKey,
    totalPaid: CashAmountToJSON(value.totalPaid),
    totalOwed: CashAmountToJSON(value.totalOwed),
    licensingDue: CashAmountToJSON(value.licensingDue),
    breakdown: (value.breakdown as Array<any>).map(
      DirectorLicensingFeePerRateBreakdownToJSON
    ),
  }
}
